import { render } from "./ContactUs.vue?vue&type=template&id=d7ffb9b6&scoped=true&ts=true"
import script from "./ContactUs.vue?vue&type=script&lang=ts"
export * from "./ContactUs.vue?vue&type=script&lang=ts"

import "./ContactUs.vue?vue&type=style&index=0&id=d7ffb9b6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/sms-166dx-web-frontend-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7ffb9b6"]])

export default __exports__